import { useEffect, useState } from "react";
import type { Deprecation } from "@models/providerCatalog";
import { providerCatalogApi } from "@services/providerCatalogApi";

let cache: Promise<Deprecation[]> | null = null;

/** Admin-entered model deprecations (cached per session); empty when not readable. */
export const useDeprecations = (enabled: boolean) => {
  const [deprecations, setDeprecations] = useState<Deprecation[]>([]);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    // A failure (no permission, older core) only means no warnings, never a broken editor.
    cache ??= Promise.resolve().then(() => providerCatalogApi().deprecations()).catch(() => {
      cache = null;
      return [];
    });
    cache.then((list) => alive && setDeprecations(list));
    return () => {
      alive = false;
    };
  }, [enabled]);
  return {
    deprecations,
    find: (providerKey: string, modelId: string) =>
      deprecations.find((d) => d.provider_key === providerKey && d.model_id === modelId) ?? null,
  };
};
